import { createFileRoute, redirect } from '@tanstack/react-router';
import { z } from 'zod';

export const Route = createFileRoute('/login')({
  validateSearch: z.object({
    redirect: z.string().optional(),
  }),
  beforeLoad: async ({ context, search }) => {
    if (await context.auth.checkAuthenticated()) {
      if (search.redirect) {
        const decoded = decodeURIComponent(search.redirect);
        const url = new URL(decoded, window.location.origin);
        const parsedSearch: Record<string, string> = {};
        url.searchParams.forEach((v, k) => {
          parsedSearch[k] = v;
        });
        throw redirect({
          to: url.pathname,
          search:
            Object.keys(parsedSearch).length > 0 ? parsedSearch : undefined,
          hash: url.hash ? url.hash.slice(1) : undefined,
          replace: true,
        });
      }
      throw redirect({ to: '/', replace: true });
    }
    if (search.redirect) {
      sessionStorage.setItem('auth_redirect_url', search.redirect);
    } else {
      sessionStorage.removeItem('auth_redirect_url');
    }
  },
});
